import { Button, Container, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface ImagePageProps {
  image: string;
  nextStep(): void;
}

const SurveyImage: React.FC<ImagePageProps> = ({ image, nextStep }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Container maxWidth="xl">
      <Paper className={classes.paper} elevation={1}>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid size={{ xs: 12, md: 7 }}>
            <Paper elevation={0} className={classes.imgPaper}>
              <img className={classes.image} src={image} alt="Survey" />
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Paper elevation={0} className={classes.instructions}>
              <Typography variant="subtitle1" gutterBottom>
                {t('pictureStoryTodo1')}
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                {t('pictureStoryTodo2')}
              </Typography>
              <ul className={classes.questionList}>
                <li><Typography>{t('pictureStoryQuestion1')}</Typography></li>
                <li><Typography>{t('pictureStoryQuestion2')}</Typography></li>
                <li><Typography>{t('pictureStoryQuestion3')}</Typography></li>
                <li><Typography>{t('pictureStoryQuestion4')}</Typography></li>
                <li><Typography>{t('pictureStoryQuestion5')}</Typography></li>
                <li><Typography>{t('pictureStoryQuestion6')}</Typography></li>
              </ul>
            </Paper>
          </Grid>
          <Grid size={12} className={classes.buttonRow}>
            <Button onClick={nextStep} color="primary" variant="contained" size="large">
              {t('continue')}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  image: {
    height: 'auto',
    width: '100%',
    maxHeight: '500px',
    objectFit: 'contain',
    display: 'block',
  },
  instructions: {
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    height: '100%',
    minHeight: '300px',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      minHeight: 'auto',
    },
  },
  imgPaper: {
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    display: 'flex',
    height: '100%',
    minHeight: '300px',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      minHeight: 'auto',
    },
  },
  questionList: {
    lineHeight: 2.2,
    paddingLeft: theme.spacing(2.5),
    '& li': {
      marginBottom: theme.spacing(1),
    },
  },
  buttonRow: {
    textAlign: 'right',
    marginTop: theme.spacing(1),
  },
}));

export default React.memo(SurveyImage);
